<template>
  <div>
    <vue-progress-bar></vue-progress-bar>
    <form @submit.prevent="submitForm" v-if="!entryLimitReached">
      <div v-if="Object.keys(item).length > 0 && item.mail.from.length > 8 && item.mail.to.length > 8 && !sending.done">
        <template v-for="(formField, index) in item.fields" v-if="checkDependsOn(formField)">
          <section v-show="formField.belongsToStep == 0 || formField.belongsToStep == steps.current || multistep == 0">
            <template v-if="formField.type == 'input' && formField.subtype != 'checkbox' && formField.subtype != 'radio' && formField.subtype != 'file' && formField.subtype != 'optin'">
              <c-input :class="{ 'error': errors.indexOf(index) > -1 }" :key="formField.id" v-model="formField.value" :field="formField" :currentLanguage="currentLanguage" :disabled-status="disabledStatus" @change="clearError(index)">
              </c-input>
            </template>
            <template v-if="formField.subtype == 'file'">
              <c-file :class="{ 'error': errors.indexOf(index) > -1 }" :key="formField.id" @input="inputChanged($event, index)" v-model="formField.value" :field="formField" :currentLanguage="currentLanguage" :disabled-status="disabledStatus" :field-index="index" :remove-file="removeFile" :files="item.attachments[index]" @change="clearError(index)">
              </c-file>
            </template>
            <template v-if="formField.type == 'input' && formField.subtype == 'checkbox'">
              <c-checkbox :class="{ 'error': errors.indexOf(index) > -1 }" :multi-check="multiCheck" :field-index="index" :key="formField.id" v-model="formField.value" :field="formField" :currentLanguage="currentLanguage" :disabled-status="disabledStatus" @input="clearError(index)">
              </c-checkbox>
            </template>
            <template v-if="formField.type == 'input' && formField.subtype == 'optin'">
              <c-optin :class="{ 'error': errors.indexOf(index) > -1 }" :field-index="index" :key="formField.id" v-model="formField.value" :field="formField" :currentLanguage="currentLanguage" :disabled-status="disabledStatus" @input="clearError(index)">
              </c-optin>
            </template>
            <template v-if="formField.type == 'input' && formField.subtype == 'radio'">
              <c-radio :class="{ 'error': errors.indexOf(index) > -1 }" :key="formField.id" v-model="formField.value" :field="formField" :currentLanguage="currentLanguage" :disabled-status="disabledStatus" @change="clearError(index)">
              </c-radio>
            </template>
            <template v-if="formField.type == 'textarea'">
              <c-textarea :class="{ 'error': errors.indexOf(index) > -1 }" :key="formField.id" v-model="formField.value" :field="formField" :currentLanguage="currentLanguage" :disabled-status="disabledStatus" @change="clearError(index)">
              </c-textarea>
            </template>
            <template v-if="formField.type == 'select'">
              <c-select :class="{ 'error': errors.indexOf(index) > -1 }" :key="formField.id" v-model="formField.value" :field="formField" :currentLanguage="currentLanguage" :disabled-status="disabledStatus" @change="clearError(index)">
                <option v-if="formField.defaultSelectText[currentLanguage]" value="" selected disabled>{{ formField.defaultSelectText[currentLanguage] }}</option>
              </c-select>
            </template>
            <template v-if="formField.type == 'address'">
              <c-address v-if="Object.keys(countries).length > 0" :countries="countries" :class="{ 'error': errors.indexOf(index) > -1 }" :key="formField.id" v-model="formField.value" :field="formField" :currentLanguage="currentLanguage" :disabled-status="disabledStatus" @change="clearError(index)">
              </c-address>
            </template>
            <template v-if="formField.type == 'description'">
              <c-description :key="formField.id" :field="formField" :currentLanguage="currentLanguage">
              </c-description>
            </template>
          </section>
          <template v-if="formField.type == 'step'">
            <section v-show="formField.step == steps.current">
              <c-step :key="formField.id" :field="formField" :currentLanguage="currentLanguage">
              </c-step>
            </section>
          </template>
        </template>
        <div>
          <template v-if="item.recaptcha.sitekey.length > 0 && (!multistep || steps.current == multistep || nextAvailableStep(steps.current) > multistep)">
            <g-recaptcha
              :data-sitekey="item.recaptcha.sitekey" 
              :data-validate="validateForm"
              :data-callback="submitForm"
              data-badge="inline"
              data-btn-class="right"
              :data-btn-disabled="uploading || errors.length > 0 || sending.progress"
              :disabled="uploading || errors.length > 0 || sending.progress"
            >{{ item.mail.messages.send[currentLanguage] }}
            </g-recaptcha>
          </template>
          <template v-if="item.recaptcha.sitekey.length < 1 && (!multistep || steps.current == multistep || nextAvailableStep(steps.current) > multistep)">
            <button class="right" type="submit" :disabled="uploading || errors.length > 0 || sending.progress" @click.prevent="validateForm(true)">{{ item.mail.messages.send[currentLanguage] }}</button>
          </template>
          <section style="display:inline;" v-show="multistep && prevAvailableStep(steps.current) > 0">
            <button type="submit" :disabled="uploading || errors.length > 0 || sending.progress" @click.prevent="prevStep">Vorige</button>
          </section>
          <section style="display:inline;" v-show="multistep && nextAvailableStep(steps.current) <= multistep">
            <button class="right" type="submit" :disabled="uploading || errors.length > 0 || sending.progress" @click.prevent="nextStep">Volgende</button>
          </section>
        </div>
      </div>
    </form>
    <div v-if="sending.done && !sending.error">
      <p>{{ item.mail.messages.success[currentLanguage] }}</p>
    </div>
    <div v-if="sending.done && sending.error">
      <p>{{ item.mail.messages.error[currentLanguage] }}</p>
    </div>
    <div v-if="entryLimitReached">
      <p>U heeft al een beoordeling geplaatst.</p>
    </div>
  </div>
</template>

<script>
import CSelect from './components/elements/select'
import CRadio from './components/elements/radio'
import CCheckbox from './components/elements/checkbox'
import COptIn from './components/elements/optin'
import CInput from './components/elements/input'
import CTextarea from './components/elements/textarea'
import CAddress from './components/elements/address'
import CStep from './components/elements/step'
import CDescription from './components/elements/description'
import CFile from './components/elements/file'
import gRecaptcha from '@finpo/vue2-recaptcha-invisible'

export default {
  name: 'FormRender',
  components: {
    'c-select': CSelect,
    'c-radio': CRadio,
    'c-input': CInput,
    'c-checkbox': CCheckbox,
    'c-optin': COptIn,
    'c-textarea': CTextarea,
    'c-address': CAddress,
    'c-step': CStep,
    'c-description': CDescription,
    'c-file': CFile,
    'gRecaptcha': gRecaptcha
  },
  data () {
    return {
      steps: {
        current: 1
      },
      mode: 'render',
      uploading: false,
      multistep: 0,
      id: window.$id,
      authenticated: window.$authenticated,
      userdata: window.$data,
      currentLanguage: window.$language,
      entryLimitReached: false,
      stepFields: [],
      item: {},
      data: [],
      errors: [],
      countries: {},
      sending: {
        progress: false,
        done: false,
        error: false
      },
      dataToSend: {}
    }
  },
  methods: {
    nextAvailableStep (current) {
      const allSteps = this.item.fields.filter(field => {
        return field.type === 'step' && field.step > current
      })
      let next = this.multistep + 1
      allSteps.some(field => {
        if (this.checkDependsOn(field)) {
          next = field.step
          return true
        }
      })
      return next
    },
    prevAvailableStep (current) {
      const allSteps = this.item.fields.filter(field => {
        return field.type === 'step' && field.step < current
      })
      let prev = 0
      allSteps.forEach(field => {
        if (this.checkDependsOn(field)) {
          prev = field.step
        }
      })
      return prev
    },
    prevStep () {
      this.steps.current = this.prevAvailableStep(this.steps.current)
    },
    nextStep () {
      const checkForm = this.validateForm(false)
      if (checkForm) {
        this.steps.current = this.nextAvailableStep(this.steps.current)
      }
    },
    disabledStatus (state) {
      return this.mode === 'builder' ? true : state
    },
    checkDependsOn (field) {
      let notMatched = false
      if (field.dependson.length > 0) {
        field.dependson.forEach(dependency => {
          const dependencyField = this.item.fields.filter(depField => {
            return depField.id === dependency.field
          })[0]
          if (dependency.value === 'filled') {
            if (dependencyField.value.length < 1) {
              notMatched = true
            }
          } else if (dependency.value === 'empty') {
            if (dependencyField.value.length > 0) {
              notMatched = true
            }
          } else {
            if (dependencyField.value instanceof Array) {
              if (dependencyField.value.indexOf(dependency.value) < 0) {
                notMatched = true
              }
            } else {
              if (dependencyField.value !== dependency.value) {
                notMatched = true
              }
            }
          }
        })
      }
      return !notMatched
    },
    clearError (index) {
      if (this.errors.indexOf(index) > -1) {
        this.errors.splice(this.errors.indexOf(index), 1)
      }
    },
    multiCheck (e, index) {
      if (this.item.fields[index].value.indexOf(e) > -1) {
        this.item.fields[index].value.splice(this.item.fields[index].value.indexOf(e), 1)
      } else {
        this.item.fields[index].value.push(e)
      }
    },
    inputChanged (e, index) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return false
      }
      if (!(this.item.fields[index].value instanceof Array)) {
        this.item.fields[index].value = []
      }
      Object.keys(files).forEach(key => {
        const file = files[key]
        this.uploading = true
        const reader = new FileReader()
        reader.onload = (event) => {
          this.$nextTick(() => {
            if (!(this.item.attachments instanceof Object)) {
              let tempObj = {}
              tempObj.attachments = {}
              this.item = Object.assign({}, this.item, tempObj)
            }
            if (!(this.item.attachments[index] instanceof Array)) {
              let tempObj = {}
              tempObj[index] = []
              this.item.attachments = Object.assign({}, this.item.attachments, tempObj)
            }
            this.item.attachments[index].push({
              type: file.type,
              name: file.name,
              content: event.target.result.split(',')[1]
            })
            this.uploading = false
          })
        }
        reader.readAsDataURL(file)
      })
    },
    removeFile (field, file) {
      this.item.attachments[field].splice(file, 1)
    },
    validateForm (normalSubmit) {
      this.data = []
      const form = JSON.parse(JSON.stringify(this.item))
      let senderAddress = ''
      let optin = {}
      form.fields.forEach((field, index) => {
        if (field.type === 'description') {
          return
        }
        if (!normalSubmit) {
          if (field.required) {
            if (this.multistep > 0) {
              if (field.belongsToStep === this.steps.current) {
                if (!field.value || (field.value && field.value.length === 0)) {
                  if (this.checkDependsOn(this.stepFields[field.belongsToStep - 1]) && this.checkDependsOn(field)) {
                    this.errors.push(index)
                  }
                }
              }
            } else {
              if (!field.value || (field.value && field.value.length === 0)) {
                this.errors.push(index)
              }
            }
          }
        } else {
          if (field.required && field.value && field.value.length === 0) {
            if (this.multistep > 0 && field.belongsToStep > 0) {
              if (this.checkDependsOn(this.stepFields[field.belongsToStep - 1]) && this.checkDependsOn(field)) {
                this.errors.push(index)
              }
            } else {
              this.errors.push(index)
            }
          } else if (field.required && !field.value) {
            if (this.multistep > 0 && field.belongsToStep > 0) {
              if (this.checkDependsOn(this.stepFields[field.belongsToStep - 1]) && this.checkDependsOn(field)) {
                this.errors.push(index)
              }
            } else {
              this.errors.push(index)
            }
          }
        }

        if (this.item.mail.sender.copy && this.item.mail.sender.field.length > 2 && field.id === this.item.mail.sender.field) {
          senderAddress = field.value
        }
        if (field.subtype === 'optin') {
          optin = field
        }
        let value = field.value
        if (field.options && field.options.length > 0) {
          value = field.options.filter(option => {
            if (field.value instanceof Array) {
              return field.value.indexOf(option.value) > -1
            } else {
              return option.value === field.value
            }
          })
          value.forEach((val, index) => {
            value[index] = value[index].label
          })
        }
        if (field.subtype === 'file') {
          value = form.attachments[index]
        }
        if (field.type === 'address') {
          if (!normalSubmit) {
            if (this.multistep > 0 && field.belongsToStep > 0) {
              if (field.belongsToStep === this.steps.current) {
                if (this.checkDependsOn(this.stepFields[field.belongsToStep - 1]) && this.checkDependsOn(field)) {
                  if (!(this.countries[value.country.countrycode] instanceof Object) && field.required) {
                    this.errors.push(index)
                  } else {
                    value.country = this.countries[value.country.countrycode]
                  }
                }
              }
            } else {
              if (!(this.countries[value.country.countrycode] instanceof Object) && field.required) {
                this.errors.push(index)
              } else {
                value.country = this.countries[value.country.countrycode]
              }
            }
          } else {
            if (this.multistep > 0 && field.belongsToStep > 0) {
              if (this.checkDependsOn(this.stepFields[field.belongsToStep - 1]) && this.checkDependsOn(field)) {
                if (!(this.countries[value.country.countrycode] instanceof Object) && field.required) {
                  this.errors.push(index)
                } else {
                  value.country = this.countries[value.country.countrycode]
                }
              }
            } else {
              if (!(this.countries[value.country.countrycode] instanceof Object) && field.required) {
                this.errors.push(index)
              } else {
                value.country = this.countries[value.country.countrycode]
              }
            }
          }
        }
        if (this.multistep > 0) {
          if (field.belongsToStep && field.belongsToStep === 1) {
            if (this.checkDependsOn(field)) {
              this.data.push({
                name: field.name,
                label: field.label,
                value: value,
                dbField: field.dbField
              })
            }
          } else {
            if (field.belongsToStep && this.checkDependsOn(this.stepFields[field.belongsToStep - 1]) && this.checkDependsOn(field)) {
              this.data.push({
                name: field.name,
                label: field.label,
                value: value,
                dbField: field.dbField
              })
            }
          }
        } else {
          this.data.push({
            name: field.name,
            label: field.label,
            value: value,
            dbField: field.dbField
          })
        }
      })

      const allEmail = this.item.fields.filter(field => {
        return field.subtype === 'email'
      })
      if (this.multistep > 0 && senderAddress.length < 3 && allEmail.length > 0 && this.item.mail.sender.field.length < 1) {
        allEmail.forEach((field, index) => {
          if (this.item.mail.sender.copy && field.subtype === 'email' && field.value && field.value.length > 8) {
            senderAddress = field.value
          }
        })
      }

      if (this.errors.length === 0) {
        this.dataToSend = {
          data: this.data,
          attachments: this.item.attachments,
          language: this.currentLanguage,
          mail: this.item.mail,
          name: this.item.name,
          sender: senderAddress,
          optin: optin
        }
        if (normalSubmit) {
          this.sendForm()
        }
        return true
      } else {
        return false
      }
    },
    submitForm (token) {
      if (typeof token === 'string' || token instanceof String) {
        this.axios.put('/api/v2/Forms/recaptcha/' + this.id, {
          token: token
        })
          .then(response => {
            if (response.data.success) {
              this.sendForm()
            }
          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    sendForm () {
      this.$Progress.start()
      this.axios.put('/api/v2/Forms/submitForm/' + this.id, this.dataToSend)
        .then(response => {
          this.dataToSend = {}
          if (response.data.error || response.data.errors) {
            this.sending.error = true
            this.$Progress.fail()
          } else {
            if (response.data.result.system[0].status === 'rejected' || response.data.result.system[0].status === 'invalid') {
              this.sending.error = true
            }
            if (this.item.mail.sender.copy) {
              if (response.data.result.copy[0].status === 'rejected' || response.data.result.copy[0].status === 'invalid') {
                this.sending.error = true
              }
            }
            this.sending.progress = false
            this.sending.done = true
            if (this.sending.error) {
              this.$Progress.fail()
            } else {
              this.$Progress.finish()
            }
          }
        })
        .catch(error => {
          this.dataToSend = {}
          this.sending.progress = false
          this.sending.done = true
          this.sending.error = true
          console.error(error)
          this.$Progress.fail()
        })
    }
  },
  created () {
    if (this.authenticated) {
      this.userdata = JSON.parse(this.userdata)
    }
    this.$Progress.start()
    this.axios.get('/api/v2/Forms/getRenderForm/' + this.id)
      .then(response => {
        this.item = Object.assign({}, response.data, { attachments: {} })
        let emailField = {}
        this.item.fields.forEach((field, index) => {
          if (field.subtype === 'checkbox' && field.multi) {
            this.item.fields[index].value = []
          }
          if (field.subtype === 'email') {
            emailField = field
          }
          if (field.type === 'step') {
            this.multistep++
            this.item.fields[index].step = this.multistep
            this.stepFields[this.multistep - 1] = field
          } else {
            this.item.fields[index].belongsToStep = this.multistep
          }
          if (typeof field.autofill === 'object' && field.autofill !== null) {
            if (field.type === 'step') {
              return
            }
            if (field.type === 'address') {
              try {
                this.item.fields[index].value = {
                  street: this.userdata[field.autofill.street.plugin][field.autofill.street.field],
                  number: this.userdata[field.autofill.number.plugin][field.autofill.number.field],
                  zipcode: this.userdata[field.autofill.zipcode.plugin][field.autofill.zipcode.field],
                  residence: this.userdata[field.autofill.residence.plugin][field.autofill.residence.field],
                  country: this.userdata[field.autofill.country.plugin][field.autofill.country.field]
                }
              } catch (err) {
              }
            } else if (!Array.isArray(field.autofill)) {
              try {
                this.item.fields[index].value = this.userdata[field.autofill.plugin][field.autofill.field]
              } catch (err) {
              }
            }
          }
        })
        if (this.item.reviews && this.item.reviews.enabled) {
          if (this.item.reviews.limit === 1) {
            let currentuser = Object.keys(this.userdata)
            if (currentuser.length > 0) {
              currentuser = currentuser[0]
              let user = this.userdata[currentuser]
              if (user.length > 0) {
                user = user['email']
              }
              const entries = this.item.data.filter(obj => {
                return obj[emailField.label.nl] === user
              })
              if (entries.length > 0 && !this.item.reviews.canEdit) {
                this.entryLimitReached = true
              } else if (entries.length > 0 && this.item.reviews.canEdit) {
                this.entryLimitReached = true // nog aanpassen voor bewerken eerder ingevulde beoordeling
              }
            }
          }
        }
        let hasSendToField = this.item.fields.filter(field => {
          return field.id === this.item.mail.sender.field
        })
        const originalSendCopy = this.item.mail.sender.copy
        if (this.item.mail.sender.copy && !hasSendToField.length > 0) {
          this.item.mail.sender.copy = false
        }
        const emailFields = this.item.fields.filter(field => {
          return field.subtype === 'email'
        })
        if (originalSendCopy && this.multistep > 0 && emailFields.length > 1) {
          this.item.mail.sender.copy = true
        }

        this.item.mail.messages.success[this.currentLanguage] = this.item.mail.messages.success[this.currentLanguage] || this.item.mail.messages.success.nl || 'success'
        this.item.mail.messages.error[this.currentLanguage] = this.item.mail.messages.error[this.currentLanguage] || this.item.mail.messages.error.nl || 'error'
        this.item.mail.messages.send[this.currentLanguage] = this.item.mail.messages.send[this.currentLanguage] || this.item.mail.messages.send.nl || 'send'
        if (this.item.mail.type === 'smtp') {
          if (!this.item.mail.smtp.server || !this.item.mail.smtp.port) {
            this.item.mail.type = 'mailchimp'
          }
        }
        const address = this.item.fields.filter(field => {
          return field.type === 'address'
        })
        this.$Progress.finish()
        if (address.length > 0) {
          this.$Progress.start()
          this.axios.get('/countries/' + this.currentLanguage + '/country.json')
            .then(response => {
              this.countries = response.data
              Object.keys(response.data).forEach(country => {
                let tempObj = {}
                tempObj['nl'] = response.data[country]
                this.countries[country] = Object.assign({}, tempObj)
              })
              this.$Progress.finish()
            })
            .catch(error => {
              console.error(error)
              this.$Progress.fail()
            })
        }
      })
      .catch(error => {
        console.error(error)
        this.$Progress.fail()
      })
  }
}
</script>

<style>
.required {
  color: red !important;
}
.small {
  font-size: 1.2rem;
  margin-top: 0;
  padding-bottom: 2rem;
}
.error input, .error select, .error textarea, .error .control-indicator {
  border: 1px solid red;
}
form {
  z-index: 999 !important;
}
.optin-field > .control-label {
  margin-left: 2.8rem;
  margin-top: -0.2rem;
  margin-bottom: 0.2rem;
}
.optin-field > .control-label > p {
  font-size: 1.4rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue